// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"65":"47412e8f03c3df4bb2dc","223":"2f7e86804b065a789940"}[chunkId] + ".css";
};